import { Reducer } from 'react';
import { Actions } from '../../actions/equipmentProfile';
import { Action, EquipmentProfileState } from '../../types';
import loadNotes from '../../../assets/loadNotes.png';
import loadIcon from '../../../assets/loadIcon.png';

const initialEquipmentProfileState: EquipmentProfileState = {
    tabs: [
        {
            key: 0,
            displayName: 'Load Progress',
            icon: loadIcon,
            isSelected: true,
        },
        {
            key: 1,
            displayName: 'Load Notes',
            icon: loadNotes,
            isSelected: false,
        },
    ],
};

const setEquipmentSelectedTab = (payload: number, state: EquipmentProfileState): EquipmentProfileState => {
    return {
        ...state,
        tabs: state.tabs.map((tab): any => {
            const isSelected = tab.key === payload;
            return { ...tab, isSelected: isSelected };
        }),
    };
};

const equipmentProfileReducer: Reducer<EquipmentProfileState, Action> = (state, action): EquipmentProfileState => {
    let newState = { ...state };

    switch (action.type) {
        case Actions.SET_EQUIPMENT_SELECTED_TAB:
            newState = setEquipmentSelectedTab(action.payload, state);
            break;
    }

    return newState;
};

export { initialEquipmentProfileState, equipmentProfileReducer };
